<template>
  <div class="index py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.appellation.list")}}</span>
    <div class="list-container">
      <AveineAppellationList :APIbaseURL="APIbaseURL" :adminMode="true"/>
    </div>
  </div>
</template>

<script>
import { AveineAppellationList } from 'aveine-appellation';

export default {
  name: 'Index',
  data() {
    return {
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  components: {
    AveineAppellationList
  }
}
</script>
